import { render, staticRenderFns } from "./expend.vue?vue&type=template&id=28291455&scoped=true"
import script from "./expend.vue?vue&type=script&lang=js"
export * from "./expend.vue?vue&type=script&lang=js"
import style0 from "./expend.vue?vue&type=style&index=0&id=28291455&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28291455",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28291455')) {
      api.createRecord('28291455', component.options)
    } else {
      api.reload('28291455', component.options)
    }
    module.hot.accept("./expend.vue?vue&type=template&id=28291455&scoped=true", function () {
      api.rerender('28291455', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/expend.vue"
export default component.exports